<div *ngIf="loading">
  <!-- <div class="lds-ring">
    <div class="{{class}}"></div>
    <div class="{{class}}"></div>
    <div class="{{class}}"></div>
    <div class="{{class}}"></div>
  </div> -->
  <div class="nb-spinner {{class}}"></div>
</div>